export enum ProfileType {
    LENDER = "LENDER",
    PROVIDER = "PROVIDER"
}
